let config = {
  Navigation: {
    homePage:'Home Page',
    ComplaintInquiry:'Complaint Search',
  },
  complaintForm: {
    title1: ' Region ',
    title2: ' Your information ',
    title3: ' Your complaintModel ',
    title4: ' Complaint confirmation',
    located: 'Where are you located?',
    misconductOccur: 'Where did the misconduct occur?',
    nextStep: 'Next',
    type:'Complaint category',
    pleaseSelect:'Please Choose',
    pleaseSelectTimes:'Please select Times',
    eventTime:'The time of occurrence',
    times:'How many times does it occur？',
    frequency:'How often does it occur?',
    continueFlag:'Is it still ongoing?',
    continueFlagSelect: {
      yes:'Yes',
      no:'No',
    },
    eventPlayers:'Please list the people involved in the issue',
    eventPlayersForms: {
      userName:'Name',
      department:'Entity/Department',
      position:'Position/Job title',
      managerFlag:'Is he/she a member in the senior management?',
      operation:'Operation',
      delete:'Delete',
      handleAddParticipant:'HandleAddParticipant',
    },
    desInformation:'Please provide a brief description of the issue',
    speechCompanyFlagFlag:'Have you ever reported the issue to the management or human resources department?',
    speechOtherFlagFlag:'Have you ever reported the issue to any other external party? ',
    speechCompanyFlag:'The information of the management or human resources department ',
    speechOtherFlag:'The information of any other external party',
    aboutOtherFlag:'Does the issue involve any external party?',
    aboutOtherFlagSelect: {
      yes:'Yes',
      no:'No',
      unKnown:'Do not know',
    },
    otherDepartment:'Name of external party',
    witnessName:'Is there any other witness? If so, please specify',
    witnessNameSelect: {
      yes:'Yes',
      no:'No',
      disclose:'Do not wish to disclose'
    },
    howToKnow:'How did you learn about the issue?',
    howToKnowSelect: {
      victim:'As a Victim',
      participant:'As a Participant',
      witness:'As a Witness',
      overhearing:'From Overhearing',
      rumours:'From Rumours',
      disclose:'Unwilling to Disclose',
    },
    authenticatorList:'witness',
    authenticatorListTable: {
      userName:'If yes, please provide their names',
      department:'Company',
      position:'Position/Job title',
      operation:'Operation',
      delete:'Delete',
      handleAddWitness:'HandleAddWitness',
    },
    sysFiles:'Upload Attachment',
    uploadTip1:'Please upload any supporting materials that you think are related to this complaintModel, including audio, video, photos, documents, etc.',
    uploadTip2:'Only files below 50MB can be uploaded. To upload more than 50MB files, please contact the administrator:',
    uploadTip3:'If you have files to upload, please send them to ',
    uploadButton:'Click Upload',
    previousStep:'Back',
    submitForm:'Submit ',
    desInformationPlaceholder: "Please fill in the contents of the complaintModel and describe clearly where it happened, what happened, and the amount involved in the event (if you know). What terms or regulations do you think are in violation. \n EXAMPLE: On the afternoon of October 13, 2016, I discovered that Zhang San had stolen a new computer from the loading dock, in violation of the Compliance Manual.",
    speechOtherFlagPlaceholder: "What time would you like to report? In what form? Reporting agency? \n EXAMPLE: On XXXX, XXXX, I reported this issue to XX.",
    speechCompanyFlagPlaceholder: "Please fill in the time and form of reporting, reporting organization and department, position or name of reporting object.\n EXAMPLE: On April 7, 2017, I informed the Director of XX Department at XX (entity) by email.",
    content:'The time zone is east eight',
    complainTypeList: {
      type1: 'Rights and Interests of Emplyees',
      type2: 'Health, Safety, and Environment (HSE)',
      type3: 'Conflict of Interest or Insider Trading',
      type4: 'Corruption, Fraud and Money-laundering',
      type5: 'Asset Utilization and Protection',
      type6: 'Data Security and Privacy',
      type7: 'Financial Reporting, Taxation, and Public Disclosure',
      type8: 'Monopoly',
      type9: 'Trade Compliance',
      type10: 'Fair Trade and Competition',
    }
  },
  statementText: {
    warning: 'Warning',
    warningContent: 'Please make sure you have saved the report number and identification code.',
    warningButton1: 'Cancel',
    warningButton2: 'Confirm',
    statementTitle:'CNOOC Limited Compliance Complaint Information Collection | Your information | Your complaintModel',
    stepActionText0:'CNOOC Limited offers an open compliance compliant channel to report misconducts, potential violations of the Comp-<br>liance Manual, other company policies, or laws and regulations. | Please Note: Do not use this site to report events presenting an immediate threat to life or property. Reports submitted<br> through this channel may not receive an immediate response. If you require emergency assistance, please contact lo-<br>cal organization.',
    stepActionText1:'We recognize you have the choice to raise this concern ano-<br>nymously, unless state/territory regulations prohibit anonymi-<br>ty. Please be discreet in telling us who you are and other pri-<br>vate information, and we also guarantee that your private inf-<br>ormation will be treated as confidential.| Past experiences show that back-forth communication facilit-<br>ates us to better understand your concern, and thus providin-<br>g your contact information would help the investigation to go<br> further. Meanwhile, acknowledging your identity would also h-<br>elp us to protect you against any risk of subsequent retaliatio-<br>n.|Again, the option to remain anonymous is yours.',
    stepActionText2:'The information you provide will be kept strictly confidential<br>and will only be accessible to those responsible for further<br> review.| The information you report may lead to internal investigatio-<br>ns and investigations by public authorities. For this reason,<br>please only provide information that is true and accurate to<br>the best of your knowledge.|The information you provide is critical for the investigation a-<br>nd verification. In order to improve the efficiency of the inve-<br>stigation and communication, please provide as much infor-<br>mation as possible with any supporting documents you con-<br>sider necessary to ensure the accuracy.',
    statementChecked:'I have read the above statement in detail',
    statementButton:'I have read'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    tagsView: 'Open Tags-View',
    fixedHeader: 'Fixed Header',
    sidebarLogo: 'Sidebar Logo'
  },
  relation: {
    question: ' What is your relationship with CNOOC Limited? |  Do you wish to provide your contact information for compliant follow-up? | Do you wish to submit your concern anonymously？',
    limiteds: {
      value1: 'Employee',
      value2: 'Partner',
      value3: 'Do not disclose',
      value4: 'Other (please specify)',
    },
    limitedOther: 'Entity/Department | Clear information',
    select: 'Yes | No',
    choose: 'Please Choose',
    telephone: 'Contact Number',
    email: 'Mailbox',
    complainName: 'Name',
    complainantRules: {
      limited: 'Please select your relationship with CNOOC',
      department: 'Please fill in your department',
      limitedText: 'Please clarify your relationship with CNOOC',
      contactInformationFlag: 'Please choose whether you are willing to leave your contact information so that we can further follow up your complaintModel',
      complainName: 'Please fill in your name',
      anonymousFlag: 'Please select whether you need to report anonymously',
      departmentLimit: 'The maximum input length is 510 characters',
      limitedTextLimit: 'The maximum input length is 510 characters',
      telephoneLimit: 'The maximum input length is 510 characters',
      emailLimit: 'The maximum input length is 510 characters',
      complainNameLimit: 'The maximum input length is 510 characters'
    },
    regionRules: {
      located:'Please fill in the country / city of the complainant',
      misconductOccur:'Please fill in the country / city where the complaintModel occurred',
      locatedLimit: 'The maximum input length is 510 characters',
      misconductOccurLimit: 'The maximum input length is 510 characters'
    },
    complaintRules: {
      type: 'Please select the type of complaintModel',
      eventTime: 'Please fill in the time when the complaintModel occurred',
      times:'Please fill in the number of complaints',
      frequency: 'Please fill in the frequency of the complaintModel' ,
      continueFlag: 'Please select whether the complaintModel is still ongoing',
      eventPlayers: {
        userName:'Please fill in the name of the person involved in the complaintModel',
        department:'Please fill in the organization of the participant in the complaintModel',
        position:'Please fill in the position of the participant in the complaintModel',
        managerFlag:'Please select whether the participant of the complaintModel is an executive',
        userNameLimit: 'The maximum input length is 510 characters',
        departmentLimit: 'The maximum input length is 510 characters',
        positionLimit: 'The maximum input length is 510 characters'
      },
      authenticatorList: {
        userName:'Please fill in the name of the witness of the complaintModel',
        department:'Please fill in the organization of the witness of the complaintModel',
        position:'Please fill in the position of the certifier of the complaintModel',
        userNameLimit: 'The maximum input length is 510 characters',
        departmentLimit: 'The maximum input length is 510 characters',
        positionLimit: 'The maximum input length is 510 characters'
      },
      desInformation: 'Please fill in the detailed description of the complaintModel',
      speechCompanyFlagFlag: 'Please select whether you have reported this matter to the company\'s management or relevant departments',
      speechCompanyFlag: 'Please fill in the detailed information that you report to the company\'s management or relevant departments' ,
      speechOtherFlagFlag: 'Please select whether you have reported this to other external agencies' ,
      speechOtherFlag: 'Please fill in the details you reported to other external organizations' ,
      aboutOtherFlag: 'Please select whether the complaintModel involves external organizations / institutions' ,
      otherDepartment: 'Please fill in the name of external organization / Organization' ,
      witnessName:  'Please select whether there are other references for the complaintModel' ,
      howToKnow: 'Please select how you knew about the incident',
      timesLimit: 'The maximum input length is 510 characters',
      frequencyLimit: 'The maximum input length is 510 characters',
      otherDepartmentLimit: 'The maximum input length is 510 characters'
    },
    emailError: 'The mailbox format is like:admin@163.com',
    button: 'Back | Next'
  },
  complaintConfirmation:{
    complaint: 'Thank you for your complaintModel. We have submitted your concern to the designated department of CNOOC Limited and will conduct verification and investigation. Your report will be treated confidentially. This report has automatically generated a unique report number and identification password. The report number and password are the evidence for follow-up of the complaintModel, please keep it properly.',
    number: 'Report key：',
    password: 'Password：',
    help1: 'For data protection concerns, the company only provides feedback on the investigation progress, and cannot share the investigation result.',
    help2: 'You can check on your report through this website by using the report key and the password.'
  },
  // history
  // 投诉查询条件
  searchRules: {
    formId: 'Report key',
    formIdPH: 'Please enter report key',
    formIdMsg: 'The report key cannot be empty',
    formKey: 'Password',
    formKeyPH: 'Please enter password',
    formKeyMsg: 'The password cannot be empty',
    searchBtn: 'search',
    resetBtn: 'reset'
  },
  complaintDetail: {
    viewDetailBtn: 'viewDetails',
    detailTitle: 'Complaint Information | Complaint feedback',
    statusMap: 'Unprocessed | processing | completed',
    msg: 'The complaint  has been received, please wait for processing',
    msg1: 'Your complaint has been accepted and is being processed',
    located:'The Located',
    misconductOccur: 'The Misconduct Occur',
    limited: 'Your relationship with CNOOC',
    department: 'Employer',
    complainTitle: 'ComplainTitle',
    submitTime: 'SubmitTime',
    frequency: 'Frequency of complained incidents',
    times: 'Number of complained incidents',
    complainName: 'ComplainName',
    eventPlayersForms: {
      managerFlag: 'Whether executive'
    },
    authenticatorListTable: {
      userName:'UserName',
      department:'Department',
      position:'Position'
    },
    file: 'Feedback the attachment'

  },
  msg: {
    msg1: 'Error reporting key or identification password',
    msg2: 'The query is successful',
    msg3: 'The query fails',
    msg4: 'Upload failed',
    msg5: 'Upload up to 10 files',
    msg6: 'Complaint successful',
    msg7: 'Verification code expired, please refresh',
    msg8: 'Verification failed',
    msg9: 'Drag the slider to complete the puzzle',
    msg10: 'Language Set Successfully',
    msg11: 'File size cannot exceed 50MB',
    msg12: 'Only files of JPG, PNG, GIF, MP4, FLV, WMV, AVI, MKV, TXT, XLSX, XLS, VSDX, DOCX, DOC, PPT, PPTX can be uploaded'
  }
}
if (process.env.VUE_APP_DESENSITIZATION) {
  config = JSON.parse(JSON.stringify(config).replace(/CNOOC Limited|cnooc/gi,'xxxxx'))
}

export default config
